// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, IconButton, Text } from 'gestalt';

type Props = {|
  currentSelection?: string,
  handleSelectionChange: (string) => void,
  selectionList: Array<string>,
  title: string,
|};

type State = {|
  isOpen: boolean,
|};

class Selector extends React.PureComponent<Props, State> {
  state = {
    isOpen: false,
  };

  renderSelectionList = () => {
    const { title, selectionList, currentSelection, handleSelectionChange } = this.props;
    return (
      <Box marginTop={1} marginBottom={2}>
        {selectionList.map((selection, index) => (
          <Box key={`${title}-${index}`}>
            <Box alignItems="center" paddingY={2} display="flex" direction="row">
              <Box flex="grow">
                <Text>{selection}</Text>
              </Box>
              <Box>
                <IconButton
                  icon={currentSelection === selection ? 'check-circle' : 'circle-outline'}
                  accessibilityLabel={i18n._('Selector option', '[bizpro]- selected value')}
                  onClick={() => handleSelectionChange(selection)}
                  size="sm"
                  iconColor="darkGray"
                />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    );
  };

  renderSubTitle = () => {
    const { currentSelection } = this.props;
    return currentSelection ? (
      <Box marginTop={1} marginBottom={2}>
        <Text size="sm" color="gray">
          {currentSelection}
        </Text>
      </Box>
    ) : null;
  };

  render() {
    const { title, selectionList } = this.props;
    const { isOpen } = this.state;

    if (!title || !selectionList || selectionList.length === 0) {
      return null;
    }

    return (
      <Box>
        <Box display="flex" alignItems="center" justifyContent="between">
          <Box minWidth={0} width="100%">
            <Text weight="bold">{title}</Text>
          </Box>
          <Box flex="none" data-test-id="clear-button">
            <IconButton
              icon={this.state.isOpen ? 'arrow-up' : 'arrow-down'}
              accessibilityLabel={i18n._('open icon', '[bizpro]- opens section')}
              onClick={() => this.setState({ isOpen: !this.state.isOpen })}
              size="sm"
            />
          </Box>
        </Box>
        {isOpen ? this.renderSelectionList() : this.renderSubTitle()}
      </Box>
    );
  }
}

export default Selector;
